import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { KamContactInfoComponent } from './components/kam-contact-info/kam-contact-info.component';
import { ContactPageComponent } from './contact-page.component';
import { KamContactInfoV2Component } from './components/kam-contact-info-v2/kam-contact-info-v2.component';

@NgModule({
  declarations: [ContactPageComponent, KamContactInfoComponent, KamContactInfoV2Component],
  imports: [CommonModule, SharedModule],
  exports: [ContactPageComponent, KamContactInfoComponent, KamContactInfoV2Component],
})
export class ContactPageModule {}
